function buildQuery(originalQuery) {
    let base = {
        period: originalQuery.period,
        businessUnit: originalQuery.businessUnit,
        mode: originalQuery.mode,
        filters: {
            logicalOperator: originalQuery.operator ? "All" : "Any",
            children: []
        },
    }
    let filters = originalQuery.filters;
    if (filters) {
        console.log('Query has filters... N#=' + filters.length)
        for (let k in filters) {
            let current = filters[k]
            let client = current.clients
            let general = current.general
            let operator = current.operator ? "All" : "Any"
            let imported = current.imported

            //if details mode, then only 'or' operator for vehicles filters
            if (base.mode === 'details') {
                for(let i in general) {
                    let el2 = general[i]; 
                    el2.operator = false
                }
            }

            let clause = {
                "logicalOperator": operator,
                "children": []
            }

            if (general) {
                let detailsCriterias = ['cdGrpLevel1', 'cdGrpLevel2', 'cdFamily', 'productBrand', 'codeFamille', 'cdProduct']
                detailsCriterias.forEach( dc => {
                    let detailCriteria = general[dc];

                    if (detailCriteria && detailCriteria.value) {
                        let innerCriteriaOperator = detailCriteria.operator ? "All" : "Any"
                        let clauseParent = {
                            "logicalOperator": innerCriteriaOperator,
                            "children": []}

                        let arrays = detailCriteria.filtersArray.filter(e => e.value)
                        console.log("Criteria=" + dc, arrays)
                        for (let item in arrays) {
                            console.log("Key=" + arrays[item]["key"])
                            let crit = (detailCriteria.hasOwnProperty('code') ? detailCriteria['code'] : dc);
                            let innerClause = {
                                "type": "query-builder-rule",
                                "query": {
                                    "rule": "bills.details." + crit,
                                    "selectedOperator": "=",
                                    "selectedOperand": dc,
                                    "value": arrays[item]["key"]
                                }
                            }
                            //special case cdFamily
                            if (general[dc].brand && general[dc].brand.key && general[dc].brand.key !== '') {
                                innerClause.query.extraCriteria = {"rule" : "details.productBrand", "value": general[dc].brand.key}
                            }

                            clauseParent.children.push(innerClause)
                        }
                        clause.children.push(clauseParent)
                    }
                })
            }
            if (client) {
                let customerCriterias = [
                    'fidelite', 'civilite', 'constructeur', 'shopZone', 'visite', 'age', 
                    'rfm1718', 'rfm1819', 'rfm1920', 'rfm2021', 'rfm2122', 'rfm2223', 'rfm2223', 'rfm2324', 'rfm2425',   
                    'contactabilite', 'cdShop', 'recommendedFamilies', 'shopType', 'pass_entretien'
                ]
                customerCriterias.forEach( cc => {
                    let customerCriteria = client[cc]
                    let clauseParent
                    if (customerCriteria && customerCriteria.value) {
                        if (cc === 'fidelite') {
                            //Special case
                            clauseParent = {
                                "type": "query-builder-rule",
                                "query": {
                                    "rule": "bills.numLoyaltyCard",
                                    "selectedOperator": "=",
                                    "value": customerCriteria.filters.adherent.value
                                }
                            }
                        }else if (cc === 'civilite') {
                            //Special case
                            let innerCriteriaOperator = customerCriteria.operator ? "All" : "Any"
                            clauseParent = {
                                "logicalOperator": innerCriteriaOperator,
                                "children": []}
                            let arrays = customerCriteria.filters
                            for (let item in arrays) {
                                if(arrays[item].value) {
                                    for(let index in arrays[item].key) {
                                        let civilityCode = arrays[item].key[0];
                                        if (civilityCode > 0) {
                                            let innerClause = {
                                                "type": "query-builder-rule",
                                                "query": {
                                                    "rule": 'civilite',
                                                    "selectedOperator": (civilityCode == 0) ? '!=' : '=',
                                                    "value": arrays[item].key[index]
                                                }
                                            }
                                            clauseParent.children.push(innerClause)
                                        }else{
                                            //special code : others
                                            let knowns = [1,2,3,4, 7, 8, 27, 9, 53, 75]
                                            let innerClause = {
                                                "type": "query-builder-rule",
                                                "query": {
                                                    "rule": 'civilite',
                                                    "selectedOperator": '!=',
                                                    "value": knowns
                                                }
                                            }
                                            clauseParent.children.push(innerClause)
                                        }
                                    }
                                }
                            }
                        }else if (cc === 'shopType') {
                            //Special case
                            clauseParent = {
                                "type": "query-builder-rule",
                                "query": {
                                    "rule": "bills.shopCompanyStatus",
                                    "selectedOperator": "=",
                                    "value": customerCriteria.filters.shopTypeValue.code
                                }
                            }
                        }
                        else if (cc === 'visite') {
                            //Special case
                            clauseParent = {
                                "type": "query-builder-rule",
                                "query": {
                                    "rule": "dtFirstPurchase",
                                    "selectedOperator": customerCriteria.filters.valueVisite.operator,
                                    "value": customerCriteria.filters.valueVisite.value
                                }
                            }
                        }
                        else if (cc === 'pass_entretien') {
                          //Special case
                          clauseParent = {
                            "type": "query-builder-rule",
                            "query": {
                              "rule": "pass_entretien",
                              "selectedOperator": customerCriteria.filters.pass_entretien.operator,
                              "value": customerCriteria.filters.pass_entretien.value
                            }
                          }
                        }
                        else if (cc === 'age') {
                            //Special case
                            clauseParent = {
                                "type": "query-builder-rule",
                                "query": {
                                    "rule": "age",
                                    "selectedOperator": customerCriteria.filters.valueAge.operator,
                                    "value": customerCriteria.filters.valueAge.value
                                }
                            }
                        }
                        else{
                            let innerCriteriaOperator = customerCriteria.operator ? "All" : "Any"
                            clauseParent = {
                                "logicalOperator": innerCriteriaOperator,
                                "children": []}
                            let arrays = customerCriteria.filtersArray.filter(e => e.value)
                            for (let item in arrays) {
                                console.log("Key=" + arrays[item]["key"])
                                let crit
                                if(arrays[item]["code"]) {
                                    crit = arrays[item]["code"]
                                }else {
                                    crit = (customerCriteria.hasOwnProperty('code') ? customerCriteria['code'] : cc);
                                }
                                let innerClause = {
                                    "type": "query-builder-rule",
                                    "query": {
                                        "rule": crit,
                                        "selectedOperator": "=",
                                        "selectedOperand": cc,
                                        "value": arrays[item]["key"]
                                    }
                                }
                                clauseParent.children.push(innerClause)
                            }
                        }
                        clause.children.push(clauseParent)
                    }
                })
            }
            if (clause.children.length > 0) {
                base.filters.children.push(clause)
            }
            if(imported) {
                let clauseParent = {
                    "logicalOperator": "Any",
                    "children": []
                }
                const key = Object.keys(imported)[0]
                const data = imported[key].data
                const operator = imported[key].operator
                if (key === "cdProduct") {
                    let cdProducts = []
                    data.forEach(el => {
                        cdProducts.push({
                                type: "query-builder-rule",
                                query: {
                                    rule: "bills.details.cdProduct",
                                    selectedOperand: "cdProduct",
                                    selectedOperator: '=',
                                    value: el
                                }
                            })
                    })
                    let innerCriteriaOperator = operator ? "All" : "Any"
                    clauseParent.children.push({
                        logicalOperator: innerCriteriaOperator,
                        children: cdProducts
                    })
                    base.filters.children.push(clauseParent)
                } else if (key === "cdShop") {
                    let cdShops = []
                    data.forEach(el => {
                        cdShops.push({
                                type: "query-builder-rule",
                                query: {
                                    rule: "bills.cdShop",
                                    selectedOperand: "cdShop",
                                    selectedOperator: '=',
                                    value: el
                                }
                            })
                    })
                    let innerCriteriaOperator = operator ? "All" : "Any"
                    clauseParent.children.push({
                        logicalOperator: innerCriteriaOperator,
                        children: cdShops
                    })
                    base.filters.children.push(clauseParent)
                }else {
                    let innerCriteriaOperator = operator ? "All" : "Any"
                    clauseParent.children.push({
                        logicalOperator: innerCriteriaOperator,
                        children: [
                            {
                                type: "query-builder-rule",
                                query: {
                                    rule: "imported",
                                    selectedOperand: key,
                                    selectedOperator: innerCriteriaOperator,
                                    value: data
                                }
                            }
                        ]
                    })
                    base.filters.children.push(clauseParent)
                }
            }
            console.log(base)
        }
    }
    return base
}

export default buildQuery